module.exports = __webpack_public_path__ + "img/watch.c68858b0.svg";